import * as React from 'react';
import { SVGProps } from 'react';

const IconTable2SizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3Zm2 7v4h7v-4H4Zm7-2H4V4h7v4Zm2 2v4h7v-4h-7Zm7-2h-7V4h7v4Zm0 8h-7v4h7v-4Zm-9 4v-4H4v4h7Z"
    />
  </svg>
);
export default IconTable2SizeM;
